import React, { useState, useEffect } from "react";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import moment from "moment";
import { Link, useParams, useHistory } from "react-router-dom";
import UserService from "../../services/user.service";
import Loading from "../../common/Loading";
import ToastBlockContainer from "../../common/ToastBlockContainer";

const SavingsView = () => {
  let history = useHistory();
  const [savingsDetails, setSavingsDetails] = useState([]);
  const [subscriptionEditUrl, setSubscriptionEditUrl] = useState("");
  const { uuid, savId, userUUID } = useParams();
  const [loader, setLoader] = useState(true);
  const [showDeleteSub, setShowDeleteSub] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [successToast, setSuccessToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [famID, setFamID] = useState();
  const UserDetails = JSON.parse(localStorage.getItem("UserDetails"));
  const [haveAccessView, setHaveAccessView] = useState(false);
  const [haveAccessAdd, setHaveAccessAdd] = useState(false);
  useEffect(() => {
    if (userUUID) {
      UserService.userProfile(userUUID).then((response) => {
        getFamilyDetails(response.userData.id);
        setSubscriptionEditUrl(
          "/edit_user_savings/" + uuid + "/" + savId + "/" + userUUID
        );
      });
    } else {
      setSubscriptionEditUrl("/edit_savings/" + uuid + "/" + savId);
      getFamilyDetails(UserDetails.id);
    }
  }, []);

  const getFamilyDetails = (userId) => {
    UserService.getUserSingleFamilyDetails(uuid, userId).then(
      (response) => {
        console.log(response);
        setFamID(response);
        getRel(response);

        UserService.getSavingsbyUser(
          savId,
          response.FamilyData.id,
          response.FamilyData.Family.id
        ).then((resp) => {
          console.log(resp.idData.rows[0]);
          setSavingsDetails(resp.idData.rows[0]);

          setTimeout(() => {
            setLoader(false);
          }, 500);
        });
      },
      (error) => {}
    );
  };

  const getRel = (data) => {
    UserService.relationData(uuid).then((response) => {
      // main user checking
      const mainUser = response.data.au.find(
        (obj) => obj.User.email === UserDetails.email
      );

      const mainArr = [];
      if (mainUser) {
        mainArr.push(mainUser);
      }

      // support user checking
      const suppUser = response.data.au.find((obj) =>
        obj.su.find(
          (family) =>
            family.Family_User &&
            family.Family_User.User.email === UserDetails.email
        )
      );

      const suppArr = [];
      if (suppUser) {
        suppArr.push(suppUser);
      }

      let newArray = [];
      newArray = [...mainArr, ...suppArr];

      let payLoad = {
        FamilyId: data.FamilyData.Family.id,
        FamilyUserId: data.FamilyData.id,
      };
      UserService.savingsAuthUsers(payLoad).then((respo) => {
        console.log(respo.viewableData);
        var res = respo.viewableData[0];
        if (userUUID === undefined) {
          debugger;
          setHaveAccessAdd(true);
          setHaveAccessView(true);
        } else {
          debugger;
          // console.log(element);
          const newEl = newArray[0].su.find(
            (element) => element.Family_User.User.email === UserDetails.email
          );
          console.log(newEl);
          //
          // { value: "any_one", label: "Anyone" },
          // { value: "el_staff", label: "Only EL staff" },
          // { value: "all_su", label: "Only your Support Users" },
          // { value: "selected_su", label: "Selected Support Users" },
          // { value: "no_one", label: "No one except me" },
          if (
            res.addPrevilege === "any_one" ||
            res.addPrevilege === "all_su" ||
            (res.addableUsers.includes(newEl.FamilyUserId) &&
              !res.viewableUsers.includes(newEl.FamilyUserId))
          ) {
            debugger;
            setHaveAccessAdd(true);
          }
          if (
            res.viewPrevilege === "any_one" ||
            res.viewPrevilege === "all_su" ||
            (res.addableUsers.includes(newEl.FamilyUserId) &&
              !res.viewableUsers.includes(newEl.FamilyUserId)) ||
            res.viewableUsers.includes(newEl.FamilyUserId)
          ) {
            debugger;
            setHaveAccessView(true);
          }
          if (
            res.addPrevilege === "el_staff" ||
            res.addPrevilege === "no_one"
          ) {
            debugger;
            setHaveAccessAdd(false);
          }
          if (
            res.viewPrevilege === "el_staff" ||
            res.viewPrevilege === "no_one"
          ) {
            debugger;
            setHaveAccessView(false);
          }
        }
      });
    });
  };

  const hexToString = (hex) => {
    return `****${Buffer.from(hex, "hex").toString("utf8").slice(-4)}`;
  };

  // Close delete confirmation
  const handleShowDeleteModal = () => {
    setShowDeleteSub(true);
  };

  // Close delete confirmation
  const handleShowDeleteSubClose = () => {
    setShowDeleteSub(false);
  };

  // Delete subscription
  const handleDeleteSubscription = (subId) => {
    setShowDeleteSub(false);
    UserService.deleteSavings(
      subId,
      famID.FamilyData.id,
      famID.FamilyData.Family.id
    ).then(
      (response) => {
        setShowToast(true);
        setSuccessToast(true);
        setToastMessage("Accounts deleted successfully");
        window.scrollTo(0, 0);

        setTimeout(() => {
          history.push(`/savings/${uuid}`);
        }, 2500);
      },
      (error) => {}
    );
  };

  return (
    <Container>
      <ToastBlockContainer
        successToast={successToast}
        showToast={showToast}
        setShowToast={setShowToast}
        toastMessage={toastMessage}
      />
      <Row className="justify-content-center gy-0 mb-6rem">
        <Col xl="21" xxl="18">
          {loader ? (
            <>
              <div className="d-flex" style={{ minHeight: "20rem" }}>
                <Loading />
              </div>
            </>
          ) : haveAccessView ? (
            <>
              <h1 className="lh-base mb-4">Account details</h1>
              <section className="bg-white p-4 p-md-6 p-lg-8 shadow rounded-4">
                <section>
                  <Row className="gy-3 gy-md-4 gy-lg-0 mb-3 mb-md-4">
                    {savingsDetails &&
                    savingsDetails.Category &&
                    savingsDetails.Category.name === "Elderly Life" ? (
                      <Col xs="auto" className="order-lg-last ms-auto"></Col>
                    ) : (
                      <Col xs="auto" className="order-lg-last ms-auto">
                        <Link
                          to={subscriptionEditUrl}
                          className="btn btn-white btn-sm btn-square d-inline-flex d-md-none"
                        >
                          <i className="fa-solid fa-edit"></i>
                        </Link>
                        <Link
                          to={subscriptionEditUrl}
                          className="btn btn-white btn-sm d-none d-md-inline-block"
                        >
                          <i className="fa-solid fa-edit me-2"></i>Edit
                        </Link>
                        <button
                          className="btn btn-danger btn-sm btn-square d-inline-flex ms-2"
                          onClick={() => handleShowDeleteModal()}
                        >
                          <i className="fa-solid fa-trash text-white"></i>
                        </button>
                      </Col>
                    )}
                  </Row>
                  <Row className="gy-3 gy-md-0 mb-5">
                    <Col>
                      <div className="small fw-medium">Name</div>
                      <div className="d-flex align-items-center gap-2">
                        <h2 class=" mb-1 mb-md-2">
                          <div class="word-break">
                            {savingsDetails && savingsDetails.name}
                          </div>
                        </h2>
                      </div>
                    </Col>
                  </Row>

                  <Row className="gy-3 gy-md-0 mb-5">
                    <Col>
                      <div className="small fw-medium">Category</div>
                      <div className="d-flex align-items-center gap-2">
                        <p className="text-dark fw-medium mb-0">
                          {savingsDetails && savingsDetails.Category
                            ? savingsDetails.Category.CategoryName === "Others"
                              ? savingsDetails.otherCategory
                              : savingsDetails.Category.CategoryName
                            : "N/A"}
                        </p>
                      </div>
                    </Col>
                  </Row>
                  <Row className="gy-3 gy-md-0 mb-5">
                    <Col>
                      <div className="small fw-medium">Subcategory</div>
                      <div className="d-flex align-items-center gap-2">
                        <p className="text-dark fw-medium mb-0">
                          {savingsDetails && savingsDetails.SubCategory
                            ? savingsDetails.SubCategory.subCategoryName ===
                              "Others"
                              ? savingsDetails.otherSubCategory
                              : savingsDetails.SubCategory.subCategoryName
                            : "N/A"}
                        </p>
                      </div>
                    </Col>
                  </Row>

                  <Row className="gy-3 gy-md-0 mb-5">
                    <Col>
                      <div className="small fw-medium">Supplier</div>
                      <div className="d-flex align-items-center gap-2 mt-2">
                        <img
                          className="img-third-party-logo"
                          src={
                            savingsDetails &&
                            savingsDetails.Supplier &&
                            savingsDetails.Supplier.logo
                          }
                          alt="supplier logo"
                          style={{
                            borderRadius: "50%",
                            border: "1px solid #a09e9e",
                          }}
                        />
                        <p className="text-dark fw-medium mb-0">
                          {savingsDetails && savingsDetails.Supplier
                            ? savingsDetails.Supplier.name === "Others"
                              ? savingsDetails.otherSupplierName
                              : savingsDetails.Supplier.name
                            : "N/A"}
                        </p>
                      </div>
                    </Col>
                  </Row>

                  <Row className="gy-3 gy-md-4 gy-lg-0 mb-3 mb-md-4">
                    {/* unless lg breakpoint */}
                    <Col lg="auto" className=" d-lg-none">
                      <div className="small fw-medium">Amount</div>
                      <p className="h2 text-primary-dark mb-0">
                        {savingsDetails ? savingsDetails.Amount : ""}
                      </p>
                    </Col>
                    {/* if lg breakpoint */}
                    <Col lg="auto" className=" d-none d-lg-block">
                      <div className="small fw-medium">Amount</div>
                      <p className="h2 text-primary-dark mb-0">
                        {savingsDetails ? savingsDetails.Amount : ""}
                      </p>
                    </Col>
                  </Row>

                  <Row className="gy-3 gy-md-4 gy-lg-0 mb-3 mb-md-4">
                    {/* unless lg breakpoint */}
                    <Col lg="auto" className=" d-lg-none">
                      <div className="small fw-medium">Account number</div>
                      <p className="text-dark fw-medium mb-0">
                        {savingsDetails
                          ? savingsDetails.accountNumber
                            ? hexToString(savingsDetails.accountNumber)
                            : "--"
                          : ""}
                      </p>
                    </Col>
                    {/* if lg breakpoint */}
                    <Col lg="auto" className=" d-none d-lg-block">
                      <div className="small fw-medium">Account number</div>
                      <p className="text-dark fw-medium mb-0">
                        {savingsDetails
                          ? savingsDetails.accountNumber
                            ? hexToString(savingsDetails.accountNumber)
                            : "--"
                          : ""}
                      </p>
                    </Col>
                  </Row>

                  <Row className="gy-3 gy-md-4 gy-lg-0 mb-3 mb-md-4">
                    {/* unless lg breakpoint */}
                    <Col lg="auto" className=" d-lg-none">
                      <div className="small fw-medium">Account details</div>
                      <p className="text-dark fw-medium mb-0">
                        {savingsDetails
                          ? savingsDetails.accountDetails
                            ? savingsDetails.accountDetails
                            : "--"
                          : ""}
                      </p>
                    </Col>
                    {/* if lg breakpoint */}
                    <Col lg="auto" className=" d-none d-lg-block">
                      <div className="small fw-medium">Account details</div>
                      <p className="text-dark fw-medium mb-0">
                        {savingsDetails
                          ? savingsDetails.accountDetails
                            ? savingsDetails.accountDetails
                            : "--"
                          : ""}
                      </p>
                    </Col>
                  </Row>

                  <Row className="gy-3 gy-md-0 mb-5">
                    <Col>
                      <div className="small fw-medium">Status</div>
                      <div
                        className={`fw-medium mb-0 ${
                          savingsDetails && savingsDetails.status
                            ? "text-success"
                            : "text-danger"
                        }`}
                      >
                        {savingsDetails && savingsDetails.status
                          ? "Active"
                          : "Inactive"}
                      </div>
                    </Col>
                  </Row>
                </section>
              </section>
            </>
          ) : (
            <section className="bg-white p-4 p-md-6 p-lg-8 shadow rounded-4">
              <div
                className=" d-flex align-items-center justify-content-center"
                style={{ height: "20rem" }}
              >
                You have no access to view this page. Please check with the Main
                User for the access
              </div>
            </section>
          )}
        </Col>
      </Row>

      {/* // Delete subscription */}
      <Modal
        show={showDeleteSub}
        onHide={handleShowDeleteSubClose}
        className="invite_au_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h2 className="h3 mb-0">Delete Account</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            All the Account related details will be deleted permanently from the
            system.
          </p>
          <p className="mb-5">Do you want to continue?</p>
          <Button variant="white" onClick={handleShowDeleteSubClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => handleDeleteSubscription(savId)}
            className="ms-3"
          >
            Yes
          </Button>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default SavingsView;
